import axios from 'axios';
import * as api from './api';

async function uploadToS3(file: any) {
  const res = await api.createPresignedPost({ file_name: file.name });
  const s3Headers = res.s3_headers;

  const formData = new FormData();
  Object.keys(s3Headers.fields).forEach((key) => {
    formData.append(key, s3Headers.fields[key]);
  });
  formData.append('file', file);

  // @ts-ignore
  return axios.post(s3Headers.url, formData).then((response) => response.url);
}

export default uploadToS3;
